'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSliderContainer = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

require('slick-carousel');

var _handlers = require('./handlers');

var _Slider = require('components/Slider');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Ponyfill for Object.entries
var entries = function entries(obj) {
  var ownProps = Object.keys(obj);
  var i = ownProps.length;
  var resArray = new Array(i); // preallocate the Array

  while (i--) {
    resArray[i] = [ownProps[i], obj[ownProps[i]]];
  }

  return resArray;
};

var initSliderContainer = exports.initSliderContainer = function initSliderContainer(sliderContainer) {
  return new Promise(function (resolve) {
    var _sliderContainer$data = sliderContainer.dataset,
        container = _sliderContainer$data.container,
        id = _sliderContainer$data.containerId,
        name = _sliderContainer$data.containerName;

    var sliderSettings = _Slider.settings[name] || _Slider.settings.default;
    var $slider = $(sliderContainer);

    entries(sliderSettings).reduce(function (events, _ref) {
      var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
          event = _ref2[0],
          handler = _ref2[1];

      return typeof handler === 'function' ? [].concat((0, _toConsumableArray3.default)(events), [{ event: event, handler: handler }]) : events;
    }, []).forEach(function (_ref3) {
      var event = _ref3.event,
          handler = _ref3.handler;
      return $slider.on(event, handler);
    });

    $slider.slick(sliderSettings);

    (0, _handlers.setState)({ id: id, container: container, change: 'slider', name: name, slider: $slider });

    resolve({ id: id, container: container, change: 'slider', name: name, slider: $slider });
  });
};